<div fxLayout="row" fxFlexFill>
        <mat-form-field fxFlex="40%" appearance="outline">
                <mat-label>Número da Reunião</mat-label>
                <textarea matInput #message name="numeroReuniao" 
                          [(ngModel)]="reuniao.numeroReuniao" 
                          cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize" 
                          cdkAutosizeMinRows="3"
                          maxlength="50">
                </textarea>
                <mat-hint align="end">{{message.value.length}} / 50</mat-hint>
        </mat-form-field>
        <mat-form-field fxFlexOffset="10px" fxFlex="20%">
                <input matInput name="dataInicio" [matDatepicker]="dataInicio" placeholder="Data de início"
                (input)="onMascaraDataInput($event)" [(ngModel)]="reuniao.dataInicio" required>
                <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
                <mat-datepicker #dataInicio></mat-datepicker>
        </mat-form-field>
        <mat-form-field fxFlexOffset="10px" fxFlex="10%">
                <input matInput #horaInicio="ngModel" mat-hide-icons="calendar" type="time" name="horaInicio"
                placeholder="Hora de início:" [(ngModel)]="reuniao.horaInicio" required>
        </mat-form-field>
        <mat-form-field fxFlexOffset="10px" fxFlex="10%">
                <input matInput #horaFim="ngModel" mat-hide-icons="calendar" type="time" name="horaFim"
                placeholder="Hora de término:" [(ngModel)]="reuniao.horaFim">
        </mat-form-field>
</div> 

<div fxLayout="row" fxFlexFill>
        <mat-form-field fxFlex="100%" appearance="outline">
                <mat-label>Tema da Reunião</mat-label>
                <textarea matInput #message name="tema" 
                          [(ngModel)]="reuniao.tema" 
                          cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize" 
                          cdkAutosizeMinRows="3" 
                          maxlength="900" required>
                </textarea>
                <mat-hint align="end">{{message.value.length}} / 900</mat-hint>
        </mat-form-field>
</div> 

<div fxLayout="row" fxFlexFill>
        <div ngModelGroup="comboTipoReuniao" fxFlex="100">
                <combo-tipo-reuniao
                        [label]="'Tipo de Reunião'"
                        [showDisplayId]="false" 
                        [obrigatorio]="false" 
                        [selecionado]="reuniao.tipoReuniao"
                        (valorChange)="onDescricaoChangeTipoReuniao($event)">
                </combo-tipo-reuniao>
        </div>
</div>
    
<div fxLayout="row" fxFlexFill>
        <mat-form-field fxFlex="100%" appearance="outline">
                <mat-label>Local da Reunião</mat-label>
                <textarea matInput #message name="local" 
                        [(ngModel)]="reuniao.local" 
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize" 
                        cdkAutosizeMinRows="3" 
                        maxlength="200" required>
                </textarea>
                <mat-hint align="end">{{message.value.length}} / 200</mat-hint>
        </mat-form-field>
        
</div>

<div fxLayout="row" fxFlexFill>
        <div ngModelGroup="comboPessoaFisica" fxFlex="100">
                <combo-pessoa-fisica
                        [label]="'Relator'"
                        [showDisplayId]="false" 
                        [obrigatorio]="false" 
                        [selecionado]="reuniao.relator"
                        (valorChange)="onNomeChangePessoaFisica($event)">
                </combo-pessoa-fisica>
        </div>
</div>

<div fxLayout="row" fxFlexFill>
        <mat-form-field fxFlex="100%" appearance="outline">
                <mat-label>Pauta da Reunião:</mat-label>
                <textarea matInput #message name="pauta" 
                        [(ngModel)]="reuniao.pauta" 
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize" 
                        cdkAutosizeMinRows="3" 
                        maxlength="1000">
                </textarea>
                <mat-hint align="end">{{message.value.length}} / 1000</mat-hint>
        </mat-form-field>
</div>

<div fxLayout="row" fxFlexFill>
        <mat-form-field fxFlex="100%" appearance="outline">
                <mat-label>Apontamentos e Deliberações da Reunião:</mat-label>
                <textarea matInput #message name="apontamentos" 
                        [(ngModel)]="reuniao.apontamentos" 
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize" 
                        cdkAutosizeMinRows="3" 
                        maxlength="2000">
                </textarea>
                <mat-hint align="end">{{message.value.length}} / 2000</mat-hint>
        </mat-form-field>
</div>

<mat-toolbar class="titulopartes">Próxima Reunião</mat-toolbar>
<div fxLayout="row" fxFlexFill>
        <mat-form-field fxFlex="80%" appearance="outline">
                <mat-label>Local da Reunião</mat-label>
                <textarea matInput #message name="localProximaReuniao" 
                        [(ngModel)]="reuniao.localProximaReuniao" 
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize" 
                        cdkAutosizeMinRows="3" 
                        maxlength="200">
                </textarea>
                <mat-hint align="end">{{message.value.length}} / 200</mat-hint>
        </mat-form-field>
        <mat-form-field fxFlexOffset="10px" fxFlex="10%">
                <mat-label>Data</mat-label>
                <input matInput name="dataProximaReuniao" [matDatepicker]="dataProximaReuniao" placeholder="Data:"
                (input)="onMascaraDataInput($event)" [(ngModel)]="reuniao.dataProximaReuniao">
                <mat-datepicker-toggle matSuffix [for]="dataProximaReuniao"></mat-datepicker-toggle>
                <mat-datepicker #dataProximaReuniao></mat-datepicker>
        </mat-form-field>
        <mat-form-field fxFlexOffset="10px" fxFlex="10%">
                <mat-label>Hora</mat-label>
                <input matInput #horaProximaReuniao="ngModel" mat-hide-icons="calendar" type="time" name="horaProximaReuniao"
                placeholder="Hora:" [(ngModel)]="reuniao.horaProximaReuniao">
        </mat-form-field>
</div>
<div ngModelGroup="participantesReuniao">
        <participantes-reuniao [reuniao]="reuniao"></participantes-reuniao>
</div>
           

